<div class="d-flex flex-column justify-content-center dialog-container">
  <div class="d-flex justify-content-end" >
    <img class="cursor-pointer" [src]="'assets/svg-icons/close.svg'" alt="" (click)="toggleSmallDeviceDialog()"/>
  </div>
  <div class="d-flex flex-column justify-content-center gap-1 ps-4 pe-4">
      <span class="d-flex title justify-content-center">{{title}}</span>
      <div class="body-text-wrapper">
        <img class="mr-1" src="assets/svg-icons/circle-actions-alert-info.svg" alt="">
        <span
          class="body-text">{{'smallDeviceDialog.content'|translate}}</span>
      </div>
  </div>
  <div class="d-flex justify-content-center ps-4 pe-4">
    <mat-checkbox [(ngModel)]="disableDialog">{{'smallDeviceDialog.noDisplay'|translate}}</mat-checkbox>
  </div>
  <div class="w-100 justify-content-center d-flex ps-4 pe-4">
    <button class="close-button" (click)="toggleSmallDeviceDialog()">{{'smallDeviceDialog.close'|translate}}</button>
  </div>
</div>

